import type { UserType } from '@/types/auth';

// Общие паттерны/предикаты для валидации auth-форм. Сообщения об ошибках задаются
// в компонентах через i18n (t()), здесь — только проверки, без текста.

export const EMAIL_PATTERN = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const NO_SPACES_PATTERN = /^\S*$/;
export const PASSWORD_MIN_LENGTH = 6;

export function isBlank(value: string | null | undefined): boolean {
  return value == null || value.trim() === '';
}

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

/** ЮЛ — 10 цифр, ИП — 12 цифр. Без выбранного типа считаем невалидным. */
export function isValidInn(value: string, type: UserType | null): boolean {
  if (type === 'LEGAL_ENTITY') {
    return /^\d{10}$/.test(value);
  }
  if (type === 'SELF_EMPLOYED') {
    return /^\d{12}$/.test(value);
  }
  return false;
}
